const AppControlApis = {
    async restartApp(): Promise<boolean> {
        const res = await window.LinkService?.request('/api/main/v1/appControl/restartApp');
        return res.code === 200;
    },
};

export default AppControlApis;